<!-- 停车场剩余车位上报接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "cmd": "reportDeviceStatus",
          "ruleList": [{
            "parkCode":"PK23",
            "deviceCode":"DC343",
            "channelCode":"CC1345",
            "status":"1"
          }]
        },
        responseCode: {
          "data": {},
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动上报车场白名单变更信息到第三方接入系统",
          urlPattern: this.commonUrls.third + "reportDeviceStatus",
          precondition: "无",
          fitSystem: "智汇云-云停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
              { info1: 'deviceCode', info2: '是', info3: 'String', info4: '设备编码' },
             { info1: 'channelCode', info2: '否', info3: 'String', info4: '通道编码' },
              { info1: 'status', info2: '是', info3: 'String', info4: '状态：1是在线，0是离线' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: []
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportDeviceStatus.vue